module.exports = __webpack_public_path__ + "static/rental-prices.74556c21.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/prices/rental-prices.pdf
// module id = 229
// module chunks = 35783957827783 267625579013595